import { PersonTypeEnum } from '@zaoblako/shared/modules/client/enums/person.type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PersonTypeEnumI18n } from '@zaoblako/shared/modules/client/i18n/person.type.enum.i18n';

/** Helper service which provides utils to work with {@link PersonTypeEnum} enumeration values. Singleton object. */
export class PersonTypeEnumHelperClass {
  private static instance: PersonTypeEnumHelperClass = null;

  /**
   * Get global {@link PersonTypeEnumHelperClass} instance. Create it if not exist.
   *
   * @returns Helper service instance ready to use
   */
  public static getInstance(): PersonTypeEnumHelperClass {
    if (!PersonTypeEnumHelperClass.instance) {
      PersonTypeEnumHelperClass.instance = new PersonTypeEnumHelperClass();
    }

    return PersonTypeEnumHelperClass.instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  /**
   * Check that received value is valid {@link PersonTypeEnum} enumeration value
   *
   * @param value Value to check
   *
   * @returns Check result (`boolean` value)
   */
  public isValid(value: unknown): value is PersonTypeEnum {
    return Object
      .values(PersonTypeEnum)
      .includes(<any>value);
  }

  /**
   * Checks that person type is not natural person (individual entrepreneur or private customer)
   *
   * @param value Value to check ({@link PersonTypeEnum} enumeration value)
   *
   * @returns Check result (`boolean` value)
   */
  public isNatural(value: PersonTypeEnum): boolean {
    return value === PersonTypeEnum.INDIVIDUAL_ENTREPRENEUR || value === PersonTypeEnum.PRIVATE_CUSTOMER;
  }

  /**
   * Get localized human-readable string representation for enumeration value.
   * If display name not found, then origin enumeration value will be returned.
   *
   * @param value Value to transform ({@link PersonTypeEnum} enumeration value)
   * @param [locale] Locale to use ({@link I18nLocalesEnum} enumeration value, {@link I18nLocalesEnum.RU_RU} by default)
   *
   * @returns Display name (`string` value)
   */
  public getDisplayName(value: PersonTypeEnum, locale = I18nLocalesEnum.RU_RU): string {
    return value
      ? (PersonTypeEnumI18n[locale]?.[value] || value)
      : '';
  }
}
